import { render, staticRenderFns } from "./MiddlePageTopMenuBar.vue?vue&type=template&id=22d316f7&"
import script from "./MiddlePageTopMenuBar.vue?vue&type=script&lang=js&"
export * from "./MiddlePageTopMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports